export enum TrafficLayerActiveTab {
    style = 'style',
    configuration = 'configuration',
}
